import template from './loading-progressbar.html';

const DIRECTIVE_NAME = LoadingProgressbar.DIRECTIVE_NAME = 'ktLoadingProgressbar';
export default function LoadingProgressbar() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: LoadingProgressbarController,
        controllerAs: '$ctrl',
        scope: {
            value: `=${DIRECTIVE_NAME}`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function LoadingProgressbarController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/loading-progressbar/loading-progressbar-component.js